import React from 'react';
import '../../styles/examination/main.css';

const Main = () => {
    return (
        <div id='examinationMain'>
            <div className="examination-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row">
                        <div className="col-md-12 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className="my-heading">Exam Schedule</h2>
                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Examination Form</th>
                                                <th>Start Date</th>
                                                <th>End Date</th>
                                                <th>Apply</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                    Link for university examination form <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://ccsuniversityweb.in/"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="apply"
                                                        >
                                                            {" "}
                                                            Apply Now
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        Annual Courses Reg &amp; Pvt for Examination &amp; Leftout
                                                        Examination Form <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://annual.ccsuniversityweb.in"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="apply"
                                                        >
                                                            {" "}
                                                            Apply Now
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        Semester Courses Leftout Examination Form <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://ccsuniversityweb.in/"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="apply"
                                                        >
                                                            {" "}
                                                            Apply Now
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        MBBS / MDS / BDS / BAMS / BUMS / MD / MS / DM and DIPLOMA Exam Form <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://exams.ccsuforms.in/"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="apply"
                                                        >
                                                            {" "}
                                                            Apply Now
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        B.P.Ed. , M.Ed. , M.P.Ed. and Pre-Ph.D. Course Work Exam Form
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://exams.ccsuforms.in/"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="apply"
                                                        >
                                                            {" "}
                                                            Apply Now
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        Even Semester Dec-2024 to Jan-2025 Exam Form
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://ccsuniversityweb.in/"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="apply"
                                                        >
                                                            {" "}
                                                            Apply Now
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="examination-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row">
                        <div className="col-md-12 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className="my-heading">Download Admit Card</h2>
                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Admit Card</th>
                                                <th>Start Date</th>
                                                <th>End Date</th>
                                                <th>Admit Card</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        Special Examination Admit Card for UG NEP ( only for session
                                                        2021- 24) <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://ccsu.aimserp.co.in/web/registration/admit-card"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="donload"
                                                            onclick="alert('Student\'s are facing issue in JIO connection. please try another connection. if not opening.');"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        Yoga/Foreign Language admit card Even Sem June-2024
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://ccsu.aimserp.co.in/web/registration/admit-card?p_p_id=admintcardgenerationpublic_WAR_aimsstudentviewportlet&p_p_lifecycle=0"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="donload"
                                                            onclick="alert('Student\'s are facing issue in JIO connection. please try another connection. if not opening.');"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        Even Semester PG NEP Programs Main/Back/EX 2024
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center" />
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        Even Semester Professional Programs Main/Back/EX 2024
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center" />
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        Even Semester Traditional Programs Main/Back/EX 2024
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center" />
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        Even Semester B.A/B.sc./B.com NEP Main/Back/Ex. 2024.
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center" />
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        B.Ed / B.Ed Special Education Yearly Main/Back/Ex. 2024
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center" />
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        Vedic Mathematics
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center" />
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        MD / MS / DM / Diploma
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center" />
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        Pre Ph.D. Course Work.
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center" />
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        BUMS / MD(Unani) / MS(Unani)
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center" />
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        BAMS / MD(Ayurveda) / MS(Ayurveda)
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center" />
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        MBBS
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://exams.ccsuforms.in/mbbs/admitlogin.php"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="donload"
                                                            onclick="alert('Student\'s are facing issue in JIO connection. please try another connection. if not opening.');"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        B.Sc. / M.Sc. Nursing
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://exams.ccsuforms.in/mscbscnur/admitlogin.php"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="donload"
                                                            onclick="alert('Student\'s are facing issue in JIO connection. please try another connection. if not opening.');"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        BPED / MPED
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center" />
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        MED
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center" />
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        BDS / MDS
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center" />
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        Assistant Professor Recruitment Test (to be held on
                                                        03-01-2024)
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center" />
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        Yearly Professional Back Paper Exam-2023
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://ccsu.aimserp.co.in/web/registration/admit-card"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="donload"
                                                            onclick="alert('Student\'s are facing issue in JIO connection. please try another connection. if not opening.');"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        ODD Semester Examination (Dec.-2023)- Traditional,
                                                        Professional &amp; NEP Exam Session 2023-24.
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://ccsu.aimserp.co.in/web/registration/admit-card"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="donload"
                                                            onclick="alert('Student\'s are facing issue in JIO connection. please try another connection. if not opening.');"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        Yearly &amp; Private Back Paper Exam-2023
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://ccsu.aimserp.co.in/web/registration/admit-card"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="donload"
                                                            onclick="alert('Student\'s are facing issue in JIO connection. please try another connection. if not opening.');"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        Campus B.A.English (Hons.) and M.A. English ODD Semester
                                                        Main Exam/ Back Exam/ Ex-Student:2023
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://ccsu.aimserp.co.in/web/registration/admit-card"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="donload"
                                                            onclick="alert('Student\'s are facing issue in JIO connection. please try another connection. if not opening.');"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        {" "}
                                                        Yearly Professional Back Paper Exam-2023
                                                        <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://ccsu.aimserp.co.in/web/registration/admit-card"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="donload"
                                                            onclick="alert('Student\'s are facing issue in JIO connection. please try another connection. if not opening.');"
                                                        >
                                                            Download
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Main;